import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotificationState, NotificationData, Notification } from './types';
import { fetchNotifications, markNotificationAsRead, dismissNotification } from './actions';
import { addNotification } from './index';

const initialState: NotificationState = {
    notifications: [],
    // totalCount: 0,
    unreadCount: 0,
    loading: 'idle',
    error: null,
};

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotifications.pending, (state) => {
                state.loading = 'pending';
                state.error = null;
            })
            .addCase(fetchNotifications.fulfilled, (state, action: PayloadAction<NotificationData>) => {
                state.loading = 'succeeded';
                state.notifications = action.payload.notifications;
                // state.totalCount = action.payload.totalCount;
                state.unreadCount = action.payload.unreadCount;
            })
            .addCase(fetchNotifications.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = (action.payload as any)?.message || 'Failed to fetch notifications';
            })

            .addCase(markNotificationAsRead.fulfilled, (state, action: PayloadAction<number>) => {
                const notification = state.notifications.find(n => n.id === action.payload);
                if (notification) {
                  notification.is_read = true;
                }
                state.unreadCount = state.notifications.filter(n => !n.is_read).length;
            })
            
            .addCase(dismissNotification.fulfilled, (state, action: PayloadAction<number>) => {
                const dismissedId = action.payload;
                const notificationToRemove = state.notifications.find(n => n.id === dismissedId);
        
                state.notifications = state.notifications.filter(n => n.id !== dismissedId);
                // state.totalCount = state.notifications.length;
                if (notificationToRemove && !notificationToRemove.is_read) {
                  state.unreadCount = state.unreadCount > 0 ? state.unreadCount - 1 : 0;
                }
            })
            
            .addCase(addNotification, (state, action: PayloadAction<Notification>) => {
                const exists= state.notifications.some((notification)=> notification.id === action.payload.id)
                if(!exists){
                    state.notifications.unshift(action.payload);
                    state.unreadCount += 1;
                }               
            });
    },
});

export default notificationSlice.reducer;
